import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import PageShell from "../dashboard/PageShell";
import {
  ArrowLeft,
  Pencil,
  Eye,
  EyeOff,
  FileText,
  Calendar,
  User,
  Building,
  Award,
  ExternalLink,
} from "lucide-react";

// Mock data for article detail
const mockArticleData = {
  id: "1",
  articleName: "dddddddd",
  author: "dddddddddd",
  email: "",
  phone: "",
  coAuthorCenter: "",
  coAuthorOutside: "",
  type: "Tạp chí trong nước",
  researchField: "Chiến lược thủy lợi của các vùng, miền và quốc gia",
  published: "Số , Tập , 2/2010",
  journal: "",
  country: "",
  doi: "",
  impactFactor: "",
  evidence: "",
  taskProduct: "",
  abstract: "",
  awards: "",
  publicationLink: "",
};

const ArticleDetail: React.FC = () => {
  const navigate = useNavigate();
  const id = useMemo(() => {
    try {
      const parts = window.location.pathname.split("/").filter(Boolean);
      return parts[parts.length - 1] || "";
    } catch {
      return "";
    }
  }, []);

  const data = mockArticleData; // In real app, fetch by id

  return (
    <PageShell title="Chi tiết bài báo">
      <div className="space-y-6">
        <div className="flex justify-between items-center">
          <div className="flex items-center gap-3 min-w-0">
            <button
              onClick={() => window.history.back()}
              aria-label="Go back"
              className="p-3 rounded-full text-[#337ab7] bg-blue-50 hover:bg-blue-100 transition-colors"
            >
              <ArrowLeft className="h-5 w-5" />
            </button>
            <h1 className="text-lg font-semibold text-gray-800 truncate">
              Chi tiết bài báo
              <span className="ml-2 text-sm font-normal text-gray-600 truncate align-middle">
                – {data.articleName}
              </span>
            </h1>
          </div>
        </div>

        <div className="bg-white rounded-lg">
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <tbody className="bg-white divide-y divide-gray-200">
                <tr className="hover:bg-gray-50">
                  <td
                    className="px-4 py-2 whitespace-nowrap font-medium text-gray-900 bg-gray-50 w-1/3"
                    style={{ fontSize: "14px" }}
                  >
                    Tên bài báo/ công trình khoa học:
                  </td>
                  <td
                    className="px-4 py-2 text-gray-900"
                    style={{ fontSize: "14px" }}
                  >
                    {data.articleName}
                  </td>
                </tr>
                <tr className="hover:bg-gray-50">
                  <td
                    className="px-4 py-2 whitespace-nowrap font-medium text-gray-900 bg-gray-50 w-1/3"
                    style={{ fontSize: "14px" }}
                  >
                    Tác giả:
                  </td>
                  <td
                    className="px-4 py-2 text-gray-900"
                    style={{ fontSize: "14px" }}
                  >
                    {data.author}
                  </td>
                </tr>
                <tr className="hover:bg-gray-50">
                  <td
                    className="px-4 py-2 whitespace-nowrap font-medium text-gray-900 bg-gray-50 w-1/3"
                    style={{ fontSize: "14px" }}
                  >
                    Email:
                  </td>
                  <td
                    className="px-4 py-2 text-gray-900"
                    style={{ fontSize: "14px" }}
                  >
                    {data.email || "-"}
                  </td>
                </tr>
                <tr className="hover:bg-gray-50">
                  <td
                    className="px-4 py-2 whitespace-nowrap font-medium text-gray-900 bg-gray-50 w-1/3"
                    style={{ fontSize: "14px" }}
                  >
                    Điện thoại:
                  </td>
                  <td
                    className="px-4 py-2 text-gray-900"
                    style={{ fontSize: "14px" }}
                  >
                    {data.phone || "-"}
                  </td>
                </tr>
                <tr className="hover:bg-gray-50">
                  <td
                    className="px-4 py-2 whitespace-nowrap font-medium text-gray-900 bg-gray-50 w-1/3"
                    style={{ fontSize: "14px" }}
                  >
                    Đồng tác giả thuộc trung tâm:
                  </td>
                  <td
                    className="px-4 py-2 text-gray-900"
                    style={{ fontSize: "14px" }}
                  >
                    {data.coAuthorCenter || "-"}
                  </td>
                </tr>
                <tr className="hover:bg-gray-50">
                  <td
                    className="px-4 py-2 whitespace-nowrap font-medium text-gray-900 bg-gray-50 w-1/3"
                    style={{ fontSize: "14px" }}
                  >
                    Đồng tác giả ngoài trung tâm:
                  </td>
                  <td
                    className="px-4 py-2 text-gray-900"
                    style={{ fontSize: "14px" }}
                  >
                    {data.coAuthorOutside || "-"}
                  </td>
                </tr>
                <tr className="hover:bg-gray-50">
                  <td
                    className="px-4 py-2 whitespace-nowrap font-medium text-gray-900 bg-gray-50 w-1/3"
                    style={{ fontSize: "14px" }}
                  >
                    Loại:
                  </td>
                  <td
                    className="px-4 py-2 text-gray-900"
                    style={{ fontSize: "14px" }}
                  >
                    {data.type}
                  </td>
                </tr>
                <tr className="hover:bg-gray-50">
                  <td
                    className="px-4 py-2 whitespace-nowrap font-medium text-gray-900 bg-gray-50 w-1/3"
                    style={{ fontSize: "14px" }}
                  >
                    Lĩnh vực nghiên cứu:
                  </td>
                  <td
                    className="px-4 py-2 text-gray-900"
                    style={{ fontSize: "14px" }}
                  >
                    {data.researchField}
                  </td>
                </tr>
                <tr className="hover:bg-gray-50">
                  <td
                    className="px-4 py-2 whitespace-nowrap font-medium text-gray-900 bg-gray-50 w-1/3"
                    style={{ fontSize: "14px" }}
                  >
                    Xuất bản:
                  </td>
                  <td
                    className="px-4 py-2 text-gray-900"
                    style={{ fontSize: "14px" }}
                  >
                    {data.published}
                  </td>
                </tr>
                <tr className="hover:bg-gray-50">
                  <td
                    className="px-4 py-2 whitespace-nowrap font-medium text-gray-900 bg-gray-50 w-1/3"
                    style={{ fontSize: "14px" }}
                  >
                    Tạp chí:
                  </td>
                  <td
                    className="px-4 py-2 text-gray-900"
                    style={{ fontSize: "14px" }}
                  >
                    {data.journal || "-"}
                  </td>
                </tr>
                <tr className="hover:bg-gray-50">
                  <td
                    className="px-4 py-2 whitespace-nowrap font-medium text-gray-900 bg-gray-50 w-1/3"
                    style={{ fontSize: "14px" }}
                  >
                    Thuộc quốc gia:
                  </td>
                  <td
                    className="px-4 py-2 text-gray-900"
                    style={{ fontSize: "14px" }}
                  >
                    {data.country || "-"}
                  </td>
                </tr>
                <tr className="hover:bg-gray-50">
                  <td
                    className="px-4 py-2 whitespace-nowrap font-medium text-gray-900 bg-gray-50 w-1/3"
                    style={{ fontSize: "14px" }}
                  >
                    DOI:
                  </td>
                  <td
                    className="px-4 py-2 text-gray-900"
                    style={{ fontSize: "14px" }}
                  >
                    {data.doi || "-"}
                  </td>
                </tr>
                <tr className="hover:bg-gray-50">
                  <td
                    className="px-4 py-2 whitespace-nowrap font-medium text-gray-900 bg-gray-50 w-1/3"
                    style={{ fontSize: "14px" }}
                  >
                    IF:
                  </td>
                  <td
                    className="px-4 py-2 text-gray-900"
                    style={{ fontSize: "14px" }}
                  >
                    {data.impactFactor || "-"}
                  </td>
                </tr>
                <tr className="hover:bg-gray-50">
                  <td
                    className="px-4 py-2 whitespace-nowrap font-medium text-gray-900 bg-gray-50 w-1/3"
                    style={{ fontSize: "14px" }}
                  >
                    Minh chứng kèm:
                  </td>
                  <td
                    className="px-4 py-2 text-gray-900"
                    style={{ fontSize: "14px" }}
                  >
                    {data.evidence || "-"}
                  </td>
                </tr>
                <tr className="hover:bg-gray-50">
                  <td
                    className="px-4 py-2 whitespace-nowrap font-medium text-gray-900 bg-gray-50 w-1/3"
                    style={{ fontSize: "14px" }}
                  >
                    SP của nhiệm vụ:
                  </td>
                  <td
                    className="px-4 py-2 text-gray-900"
                    style={{ fontSize: "14px" }}
                  >
                    {data.taskProduct || "-"}
                  </td>
                </tr>
                <tr className="hover:bg-gray-50">
                  <td
                    className="px-4 py-2 whitespace-nowrap font-medium text-gray-900 bg-gray-50 w-1/3"
                    style={{ fontSize: "14px" }}
                  >
                    Tóm tắt:
                  </td>
                  <td
                    className="px-4 py-2 text-gray-900"
                    style={{ fontSize: "14px" }}
                  >
                    {data.abstract || "-"}
                  </td>
                </tr>
                <tr className="hover:bg-gray-50">
                  <td
                    className="px-4 py-2 whitespace-nowrap font-medium text-gray-900 bg-gray-50 w-1/3"
                    style={{ fontSize: "14px" }}
                  >
                    Khen thưởng:
                  </td>
                  <td
                    className="px-4 py-2 text-gray-900"
                    style={{ fontSize: "14px" }}
                  >
                    {data.awards || "-"}
                  </td>
                </tr>
                <tr className="hover:bg-gray-50">
                  <td
                    className="px-4 py-2 whitespace-nowrap font-medium text-gray-900 bg-gray-50 w-1/3"
                    style={{ fontSize: "14px" }}
                  >
                    Link công bố:
                  </td>
                  <td
                    className="px-4 py-2 text-gray-900"
                    style={{ fontSize: "14px" }}
                  >
                    {data.publicationLink || "-"}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </PageShell>
  );
};

export default ArticleDetail;
